import { checkResponse } from '@/utils/helpers';
import { RESPONSE_SUCCESS_CODE } from '@/configs/constants';
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';
import {
  ISkinDiseaseTypeInfos,
  ISkinFeatureEntrance,
  ISkinPopularAnswerInfo
} from '../schemas/dermatological-center';

const api: ApiConfigs = {
  querySkinFeatureEntrance: {
    url: '/health/api/v1/home/skin/querySkinFeatureEntrance',
    method: 'GET'
  },
  querySkinPopularAnswerInfo: {
    url: '/health/api/v1/home/skin/querySkinPopularAnswerInfo',
    method: 'GET'
  },
  querySkinDiseaseTypeInfos: {
    url: '/health/api/v1/home/skin/querySkinDiseaseTypeInfos',
    method: 'GET'
  },
  readingVolume: {
    url: '/health/api/v1/home/skin/readingVolume',
    method: 'GET'
  }
};

const dermatologicalCenter = {
  async getSkinFeatureEntrance() {
    try {
      const response: Response<ISkinFeatureEntrance[]> = await request(
        api.querySkinFeatureEntrance,
        undefined,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getSkinPopularAnswerInfo() {
    try {
      const response: Response<ISkinPopularAnswerInfo[]> = await request(
        api.querySkinPopularAnswerInfo,
        undefined,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getSkinDiseaseTypeInfos() {
    try {
      const response: Response<ISkinDiseaseTypeInfos[]> = await request(
        api.querySkinDiseaseTypeInfos,
        undefined,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { code, result } = response;
      if (checkResponse(code, result)) {
        const tabs = result.map((item, index) => {
          return {
            key: index,
            value: item.skinDiseaseName
          };
        });
        return { result, tabs };
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async readingVolume(params) {
    try {
      const response: Response<ISkinFeatureEntrance[]> = await request(
        api.readingVolume,
        params,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { code } = response;
      if (Number(code) === RESPONSE_SUCCESS_CODE) {
        return true;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default dermatologicalCenter;
